class ContratoUsuarioDetails {
    static get $inject() {
        return ['$scope', '$filter', 'gql']
    }

    constructor($scope, $filter, gql) {
        this.apply = fun => $scope.$apply(fun)
        this.$filter = $filter
        this.gql = gql

        $scope.$watch(() => this.empresa, () => {
            if (this.empresa) {
                this.promise = this
                    .adicionarEmpresa()
                    .then(() => {
                        this.permissao.empresas.push(this.empresa)
                        this.empresa = null
                        this.apply()
                    })
            }
        })

        $scope.$watch(
            () => this.permissao.ferramentas.sort((n1, n2) => n1 < n2).join(),
            (newValue, oldValue) => {
                if (oldValue !== newValue) this.updatePermissao()
            }
        )
    }

    highlight(search, empresa) {
        const cnpj = this.$filter('cpfCnpj')(empresa.cnpj)
        const text = `${empresa.razaoSocial} - CNPJ: ${cnpj} (${empresa.cidade}/${empresa.estado})`

        return search.split(' ').reduce(this.$filter('highlight'), text)
    }

    adicionarEmpresa() {
        const query = gql`
            mutation AddFilialToPermissao($permissaoId: Int!, $empresaId: Int!){
                addFilialToPermissao(permissaoId: $permissaoId, filialId: $empresaId) {
                    id
                }
            }
        `

        return this.gql.mutate(query, { permissaoId: this.permissao.id, empresaId: this.empresa.id })
    }

    removerEmpresa(empresa) {
        const query = gql`
            mutation RemoveFilialFromPermissao($permissaoId: Int!, $empresaId: Int!){
                removeFilialFromPermissao(permissaoId: $permissaoId, filialId: $empresaId) {
                    id
                }
            }
        `

        this.promise = this
            .gql
            .mutate(query, { permissaoId: this.permissao.id, empresaId: empresa.id })
            .then(() => {
                this.permissao.empresas = this.permissao.empresas.reject(e => e.id === empresa.id)
            })
    }

    hasFerramenta(ferramenta) {
        return ferramenta && this.permissao.ferramentas.includes(ferramenta.id)
    }

    updatePermissao() {
        const query = gql`
            mutation UpdatePermissao($permissaoId: Int!, $admin: Boolean!, $ferramentas: [String]!) {
                permissao: updatePermissao(permissaoId: $permissaoId, admin: $admin, ferramentas: $ferramentas) {
                    id
                    admin
                    ferramentas
                }
            }
        `

        const ferramentas = this.permissao.ferramentas.filter(ferramentaId =>
            this.ferramentas.find(ferramenta => ferramenta.id === ferramentaId)
        )

        const variables = {
            permissaoId: this.permissao.id,
            admin: this.permissao.admin,
            ferramentas
        }

        const permissao = { ...this.permissao }

        this.promise = this.gql
            .mutate(query, variables)
            .then(({ permissao: { admin, ferramentas } }) => {
                this.permissao = {
                    ...this.permissao,
                    admin,
                    ferramentas
                }
            })
            .catch(([{ message }]) => {
                if (message === 'last_admin') {
                    this.permissao = { ...permissao, admin: true }
                    Alert.warning('A empresa precisa de pelo menos 1 usuário administrador.', 'Operação inválida!')
                }
            })
    }

    get allSelected() {
        return this.ferramentas.every(ferramenta => this.permissao.ferramentas.includes(ferramenta.id))
    }

    set allSelected(isAllSelected) {
        if (isAllSelected) {
            this.permissao.ferramentas = this.ferramentas.map(ferramenta => ferramenta.id)
        } else {
            this.permissao.ferramentas = []
        }
    }

    get filteredEmpresas() {
        return this.empresas.filter(e => !this.permissao.empresas.find(ep => ep.id === e.id))
    }
}

angular.module("eficienciaFiscalModule")
    .component("contratoUsuarioDetails", {
        controller: ContratoUsuarioDetails,
        bindings: {
            empresas: '<',
            permissao: '<',
            contratoId: '<',
            ferramentas: '<',
            onDesvincular: '&'
        },
        template: `
        <div class="well ng-scope">
            <div class="permissao" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
                <div>
                    <h4 class="no-break">{{$ctrl.permissao.usuario.nome}} <small class="text-muted">{{$ctrl.permissao.usuario.cpf | cpfCnpj}}</small></h4> 
                    <span ng-if="$ctrl.permissao.admin && $ctrl.permissao.usuario.role === 'consultor'" class="label label-warning text-bold">Admin</span>
                    <span ng-if="$ctrl.permissao.usuario.role !== 'consultor'" class="label label-success text-bold">Suporte</span>
                </div>
                <div class="text-right">
                    <div class="ferramentas" >
                        <span 
                            ng-repeat="ferramenta in $ctrl.ferramentas" 
                            ng-if="!ferramenta.grupo"
                            ng-class="$ctrl.hasFerramenta(ferramenta) ? '' : 'text-muted'" 
                            class="text-bold">
                            <abbr title="{{ferramenta.nome}}">
                                <b>{{ferramenta.sigla}}</b>
                            </abbr>
                        </span>
                    </div>
                    <span class="text-muted">{{$ctrl.permissao.empresas.length}} de {{$ctrl.empresas.length}} {{$ctrl.empresas.length > 1 ? 'filiais' : 'filial'}}</span>
                </div>
            </div>
            <div class="detalhes slide-animation" delay="300" ng-show="$ctrl.isOpen">
                <promise-tracker promise="$ctrl.promise" active="$ctrl.loading">
                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <div style="padding: 0 0 10px 0;margin-bottom: 5px;">
                                <label>Filial</label>
                                <ui-select 
                                    theme="bootstrap" 
                                    name="empresa" 
                                    ng-model="$ctrl.empresa" 
                                    style="width:100%" 
                                    ng-disabled="!$ctrl.filteredEmpresas.length || $ctrl.loading">
                                    <ui-select-match placeholder="Clique aqui para selecionar uma filial.">
                                        {{($select.selected.cnpj | cpfCnpj).slice(11)}} ({{$select.selected.cidade}}/{{$select.selected.estado}})
                                    </ui-select-match>
                                    <ui-select-choices repeat="empresa in $ctrl.filteredEmpresas | filter: $select.search">
                                        <div ng-bind-html="$ctrl.highlight($select.search, empresa)"></div>
                                    </ui-select-choices>
                                </ui-select>
                            </div>
                            <div ng-if="$ctrl.permissao.empresas.length" class="empresas-list">
                                <div class="list-group-item" ng-repeat="empresa in $ctrl.permissao.empresas">
                                    <span>{{(empresa.cnpj | cpfCnpj).slice(11)}} {{empresa.cidade}}/{{empresa.estado}}</span> 
                                    <i ng-click="$ctrl.removerEmpresa(empresa)" class="text-danger fa fa-close"></i>
                                </div>
                            </div>
                            <div class="text-center" ng-if="!$ctrl.permissao.empresas.length">
                                <span class="text-muted">Nenhuma filial vinculada ao usuário.</span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <div style="margin: 5px 0 13px 0; padding: 13px 0; border-bottom: 1px #ddd solid;">
                                <label>
                                    <input 
                                        type="checkbox"
                                        class="checkbox"
                                        ng-model="$ctrl.permissao.admin"
                                        ng-change="$ctrl.updatePermissao()"
                                        ng-disabled="$ctrl.loading">
                                    <span>Usuário administrador?</span>
                                </label>
                                <span class="pull-right" ng-show="$ctrl.loading">
                                    <i class="fa fa-spin fa-circle-o-notch"></i> Salvando...
                                </span>
                                <label class="pull-right" ng-hide="$ctrl.loading">
                                    <a href="javascript:void(0)" ng-click="$ctrl.onDesvincular()">Desvincular da empresa</a>
                                </label>
                            </div>
                            <div style="margin-bottom: 5px;">
                                <label>
                                    <input type="checkbox" class="checkbox" ng-model="$ctrl.allSelected" ng-disabled="$ctrl.loading">
                                    <span>Marcar todas as ferramentas</span>
                                </label>
                            </div>
                            <div ng-repeat="ferramenta in $ctrl.ferramentas">
                                <label ng-class="{'submodule': !!ferramenta.grupo}">
                                    <input
                                        class="checkbox"
                                        checklist-model="$ctrl.permissao.ferramentas"
                                        checklist-value="ferramenta.id"
                                        ng-disabled="$ctrl.loading"
                                        type="checkbox"
                                    >

                                    <span>{{ferramenta.nome}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </promise-tracker>
            </div>
        </div>
        `
    })
